import map from "lodash/map";
import filter from "lodash/filter";
import { LoyaltyPointsPayload } from "@/services/LoyaltyPointsService";

export const getLoyaltyBody = ({
  cart,
  quantity = 1,
  isCart = false
}: {
  cart: any;
  quantity?: number;
  isCart?: boolean;
}) => {
  const products = isCart ? filter(cart, item => item.isSelected) : cart;
  const orderItems = map(
    products,
    item =>
      ({
        productId: item.id,
        quantity: item.quantity || quantity,
        brand: item?.brand,
        parentCategory: item?.parentCategory,
        category: item?.category,
        subcategory: item?.subcategory,
        price: item?.price
      } as LoyaltyPointsPayload)
  );

  return { orderItems };
};
